import { types } from '../actions/types';

export const BrandReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.bmGetBrands:
      return { ...state, get: action.payload };
    case types.bmCreateBrand:
      return { ...state, create: action.payload };
    case types.bmUpdateBrand:
      return { ...state, update: action.payload };
    case types.bmDeleteBrandById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
